import {
  FirstAndLastNameCell,
  DevicesCell,
  ProjectsCell,
  EmailCell,
  UserLogsCell,
  UserEditCell
} from './user';

export const userTableBodyMap = {
  firstAndLastName: FirstAndLastNameCell,
  devices: DevicesCell,
  rootProject: ProjectsCell,
  email: EmailCell,
  trail: UserLogsCell,
  edit: UserEditCell
};
